import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import wish from './modules/wish'
import user from './modules/user'
import shop from './modules/shop'
import getters from './getters'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    wish,
    shop
  },
  plugins: [createPersistedState({ paths: ['app'] })],
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js